import React from 'react';
import PropTypes from 'prop-types';
import {SearchBox} from 'react-instantsearch/dom';
//import SearchYear from './SearchYear';
import YearSlider from './YearSlider';

class Search extends React.Component {
  static propTypes = {
    query: PropTypes.string,
    currentRefinement: PropTypes.string
  };
  state = {searchState: ""};

  // handleReset = (props) => {
  //   // this.props.currentRefinement = null
  //   // console.log(this);
  //   // console.log("hello");
  //   //this.props.searchState.query = "";
  //   //this.setState({currentRefinement: "hello"});
  //   console.log(this.state.currentRefinement);
  //
  // }

  render(){
    const {searchState} = this.props
    return (
      <section className="search-controls">
        <h2 className="search__heading--keyword">Search by Keyword</h2>
        <SearchBox
          translations={{placeholder: 'Search for Number Series (eg. 121) or Keyword'}}
          searchAsYouType={false}
          showLoadingIndicator={true}
          autoFocus={true}
          //onReset={this.handleReset}
          searchState = {searchState}
        />

        <h2 className="search__heading--year">Search by Year</h2>
        <p className="search__instructions">Please select a decade and a year to explore by moving blue arrow to right or left</p>

      <YearSlider  />

      </section>
    )
  }
}
export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js